import {
  OurProductsSection,
  RecentProjectsSection,
  ServicesSection
} from "shared/sections";
import {
  HeroSection,
  NumbersSection,
  TrustedPartnersSection,
} from "./components";
import "./styles.scss";

const Home = () => (
  <>
    <HeroSection />
    <NumbersSection />
    <ServicesSection />
    <TrustedPartnersSection />
    <RecentProjectsSection />
    <OurProductsSection />
    
  </>
);

export default Home;
